import _ from 'lodash';
import { createClient } from '@/shared/api';
import type { PatientReturnsQuery, PatientReturnsQueryVariables } from '@/shared/api';
import PATIENT_RETURNS_QUERY from '../queries/patientReturns';

/**
 * Loads a page of patient-return records. Runs the patientReturns query with the filter and limit and throws the first GraphQL error only when nothing came back.
 *
 * @param filter - Filter selecting the patient returns.
 * @param limit - Maximum number of records to load; defaults to 10.
 * @returns A promise resolving to the patient returns payload.
 */
const fetchPatientReturns = async (
  filter: PatientReturnsQueryVariables['filter'],
  limit = 10,
): Promise<PatientReturnsQuery['patientReturns']> => {
  const client = createClient();
  const patientReturnsResult = await client.query<
    PatientReturnsQuery,
    PatientReturnsQueryVariables
  >({
    query: PATIENT_RETURNS_QUERY,
    variables: {
      filter,
      limit,
    },
  });
  const { data, errors } = patientReturnsResult;
  const { patientReturns } = data;
  if (_.isNil(patientReturns) && errors?.length) {
    throw new Error(errors[0].message);
  }
  return patientReturns;
};

export default fetchPatientReturns;
